import { DeliverableTask, Platform } from '../constants/campaign';
import { ICampaignDeliverables } from '../interfaces/campaign.interface';

export const highlightMentions = (text: string): string => {
    return text.replace(/@\[(.*?)\]\((.*?)\)/g, (match, mentionText) => {
        return `**${mentionText}**`; // Display mention text as bold
    });
};

export const getNumberOfDeliverables = (deliverables: ICampaignDeliverables[]) => {
    // let numberOfDeliverables = 0;
    // for (let i = 0; i < deliverables.length; i++) {
    //     if (!deliverables[i].sub_deliverable) numberOfDeliverables++;
    // }
    // return numberOfDeliverables;
    return deliverables.length;
};

export const getDeliverableNumber = (
    deliverables: ICampaignDeliverables[],
    deliverable_number: number,
) => {
    let dNumber = 1;
    for (const deliverable of deliverables) {
        if (deliverable.deliverable_number === deliverable_number) return dNumber;
        if (!deliverable.sub_deliverable) dNumber++;
    }
    return dNumber;
};

export const getCampaignContent = (deliverable: ICampaignDeliverables) => {
    if (deliverable.task === DeliverableTask.RESIZE && deliverable.platform === Platform.CUSTOM) {
        return deliverable.width + ' px x ' + deliverable.height + ' px';
    } else if (deliverable.task === DeliverableTask.VARIANT) {
        return deliverable.variant_count + '. ' + deliverable.content;
    }
    return deliverable.content;
};

export const getNumberOfSubDeliverables = (
    deliverables: ICampaignDeliverables[],
    deliverableNumber: number,
) => {
    let numberOfSubDeliverables = 0;
    for (let i = 0; i < deliverables.length; i++) {
        if (
            deliverables[i].sub_deliverable &&
            deliverables[i].deliverable_number === deliverableNumber
        ) {
            numberOfSubDeliverables++;
        }
    }
    return numberOfSubDeliverables;
};

export const getFullContentForDeliverable = (
    task: string,
    content: string,
    assetType: string | undefined,
    platform: string | undefined,
) => {
    if (task === DeliverableTask.CREATE_NEW_AD) {
        return task + ' a ' + platform + ' ' + assetType + ' for ' + content;
    }
    if (task === DeliverableTask.PRODUCT_PHOTOGRAPHY) {
        return task + ' ' + content;
    }
    if (task === DeliverableTask.RESIZE) {
        return task + ' to ' + platform + ' ' + assetType + ' ' + content;
    }
    if (task === DeliverableTask.VARIANT) {
        return task + ' ' + content;
    }
    return 'Create new ad';
};
